window.addEventListener('DOMContentLoaded', function () {
  const customerLogin = document.querySelectorAll('.customer-login')
  customerLogin.forEach(function (element) {
    element.addEventListener('click', () => {
      const path = function () {
        return '/account'
      }
      location.href = `https://store.xecurify.com/moas/broker/login/shopify/${window.location.hostname}${path()}`
    })
  })

  const hashString = window.location.search
  const hashParams = new URLSearchParams(hashString)
  if (hashParams.has('hash')) {
    console.log('In setting hash')
    document.cookie = `storefront_digest=${hashParams.get('hash')}; path=/`
    const shopName = window.location.hostname
    window.location.href = `https://${shopName}/`
  }
  const logout = document.querySelector('a[href^="/account/logout"]')
  logout?.addEventListener('click', function () {
    fetch('/account/logout').then(response => response.json()).then(data => {
      if (data.success) {
        document.cookie = 'storefront_digest=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        window.location.href = '/'

      }
    })
    return false
  })

  const cartValue = getCookie('cart')
  createCookie('cart', cartValue, 15)

})
